// Dashboard: welcome, count tiles and the recent-activity feed.
export const dashboardEn = {
  'dashboard.welcome': 'Welcome, {name}',
  'dashboard.subtitle': 'What needs attention across the site today.',
  'dashboard.open': 'Open →',
  'dashboard.tile.newInquiries': 'New quote requests',
  'dashboard.tile.articles': 'Articles',
  'dashboard.tile.media': 'Media files',
  'dashboard.oldestWaiting': 'Oldest waiting {count} day|Oldest waiting {count} days',
  'dashboard.inboxClear': 'Inbox is clear',
  'dashboard.activity.title': 'Recent Activity',
  'dashboard.activity.subtitle': 'The last ten changes made in the CMS.',
  'dashboard.activity.empty': 'No activity yet.',
  'dashboard.activity.visitor': 'Website visitor',
  'dashboard.activity.mailboxSubtitle': 'Who opened, answered, marked or deleted which email, and every change to the inbox addresses.',
  'dashboard.activity.more': 'Show more',
  'dashboard.notFound.title': 'Page Not Found',
  'dashboard.notFound.body': 'This screen doesn’t exist in the CMS.',
  'dashboard.notFound.back': 'Back to dashboard',

  // Verbs of the recent-activity sentence. `{entity}` is one of the dashboard.entity.* names.
  'dashboard.verb.create': 'created {entity}',
  'dashboard.verb.update': 'updated {entity}',
  'dashboard.verb.publish': 'published {entity}',
  'dashboard.verb.unpublish': 'unpublished {entity}',
  'dashboard.verb.delete': 'deleted {entity}',
  'dashboard.verb.upload': 'uploaded {entity}',
  'dashboard.verb.deactivate': 'deactivated {entity}',
  'dashboard.verb.status': 'marked {entity} as {status}',
  'dashboard.verb.login': 'signed in',
  'dashboard.verb.login_failed': 'failed sign-in',
  'dashboard.verb.password_changed': 'changed their password',
  'dashboard.verb.login_password': 'entered the right password, code next',
  'dashboard.verb.2fa_failed': 'entered a wrong two-step code',
  'dashboard.verb.2fa_recovery_used': 'signed in with a recovery code',
  'dashboard.verb.2fa_setup': 'turned on two-step verification',
  'dashboard.verb.2fa_disabled': 'turned off two-step verification',
  'dashboard.verb.2fa_reset': 'reset someone’s two-step verification',
  'dashboard.verb.inquiryCreate': 'submitted a quote request',
  'dashboard.verb.read': 'opened {entity}',
  'dashboard.verb.reply': 'replied to {entity}',
  'dashboard.verb.mark_read': 'marked {entity} as read',
  'dashboard.verb.mark_unread': 'marked {entity} as unread',
  'dashboard.verb.access': 'changed who can use {entity}',
  'dashboard.entity.mail': 'an email',
  'dashboard.entity.livechat': 'a website chat',
  'dashboard.verb.take': 'took over {entity}',
  'dashboard.verb.release': 'gave {entity} back to the bot',
  'dashboard.verb.handoff': 'handed {entity} to a colleague',
  'dashboard.verb.suggestion': "sent the bot's suggestion in {entity}",
  'dashboard.verb.note': 'added a note to {entity}',
  'dashboard.verb.close': 'closed {entity}',
  'dashboard.entity.mail_address': 'inbox address',

  'dashboard.entity.page': 'page',
  'dashboard.entity.product_category': 'product category',
  'dashboard.entity.product': 'product',
  'dashboard.entity.industry': 'industry',
  'dashboard.entity.article': 'article',
  'dashboard.entity.swatch': 'material or finish',
  'dashboard.entity.media': 'media file',
  'dashboard.entity.inquiry': 'quote request',
  'dashboard.entity.user': 'user',
  'dashboard.entity.site_settings': 'site settings',
  'dashboard.entity.navigation': 'header and footer',
  'dashboard.entity.spec_reference': 'specification reference',
  'dashboard.entity.tracking': 'tracking settings',
} as const

export const dashboardId: Record<keyof typeof dashboardEn, string> = {
  'dashboard.welcome': 'Selamat datang, {name}',
  'dashboard.subtitle': 'Hal yang perlu diperhatikan di seluruh situs hari ini.',
  'dashboard.open': 'Buka →',
  'dashboard.tile.newInquiries': 'Permintaan penawaran baru',
  'dashboard.tile.articles': 'Artikel',
  'dashboard.tile.media': 'File media',
  'dashboard.oldestWaiting': 'Terlama menunggu {count} hari',
  'dashboard.inboxClear': 'Tidak ada permintaan baru',
  'dashboard.activity.title': 'Aktivitas Terbaru',
  'dashboard.activity.subtitle': 'Sepuluh perubahan terakhir di CMS.',
  'dashboard.activity.empty': 'Belum ada aktivitas.',
  'dashboard.activity.visitor': 'Pengunjung situs',
  'dashboard.activity.mailboxSubtitle': 'Siapa yang membuka, membalas, menandai, atau menghapus email, dan setiap perubahan alamat inbox.',
  'dashboard.activity.more': 'Tampilkan lagi',
  'dashboard.notFound.title': 'Halaman Tidak Ditemukan',
  'dashboard.notFound.body': 'Layar ini tidak ada di CMS.',
  'dashboard.notFound.back': 'Kembali ke dasbor',

  'dashboard.verb.create': 'membuat {entity}',
  'dashboard.verb.update': 'memperbarui {entity}',
  'dashboard.verb.publish': 'menerbitkan {entity}',
  'dashboard.verb.unpublish': 'membatalkan penerbitan {entity}',
  'dashboard.verb.delete': 'menghapus {entity}',
  'dashboard.verb.upload': 'mengunggah {entity}',
  'dashboard.verb.deactivate': 'menonaktifkan {entity}',
  'dashboard.verb.status': 'menandai {entity} sebagai {status}',
  'dashboard.verb.login': 'masuk',
  'dashboard.verb.login_failed': 'gagal masuk',
  'dashboard.verb.password_changed': 'mengubah kata sandinya',
  'dashboard.verb.login_password': 'memasukkan kata sandi yang benar, lanjut kode',
  'dashboard.verb.2fa_failed': 'memasukkan kode dua langkah yang salah',
  'dashboard.verb.2fa_recovery_used': 'masuk dengan kode pemulihan',
  'dashboard.verb.2fa_setup': 'mengaktifkan verifikasi dua langkah',
  'dashboard.verb.2fa_disabled': 'mematikan verifikasi dua langkah',
  'dashboard.verb.2fa_reset': 'mereset verifikasi dua langkah seseorang',
  'dashboard.verb.inquiryCreate': 'mengirim permintaan penawaran',
  'dashboard.verb.read': 'membuka {entity}',
  'dashboard.verb.reply': 'membalas {entity}',
  'dashboard.verb.mark_read': 'menandai {entity} sudah dibaca',
  'dashboard.verb.mark_unread': 'menandai {entity} belum dibaca',
  'dashboard.verb.access': 'mengubah siapa yang bisa memakai {entity}',
  'dashboard.entity.mail': 'email',
  'dashboard.entity.livechat': 'chat website',
  'dashboard.verb.take': 'mengambil alih {entity}',
  'dashboard.verb.release': 'mengembalikan {entity} ke bot',
  'dashboard.verb.handoff': 'menyerahkan {entity} ke rekan',
  'dashboard.verb.suggestion': 'mengirim saran bot di {entity}',
  'dashboard.verb.note': 'menambah catatan di {entity}',
  'dashboard.verb.close': 'menutup {entity}',
  'dashboard.entity.mail_address': 'alamat inbox',

  'dashboard.entity.page': 'halaman',
  'dashboard.entity.product_category': 'kategori produk',
  'dashboard.entity.product': 'produk',
  'dashboard.entity.industry': 'industri',
  'dashboard.entity.article': 'artikel',
  'dashboard.entity.swatch': 'bahan atau finishing',
  'dashboard.entity.media': 'file media',
  'dashboard.entity.inquiry': 'permintaan penawaran',
  'dashboard.entity.user': 'pengguna',
  'dashboard.entity.site_settings': 'pengaturan situs',
  'dashboard.entity.navigation': 'header dan footer',
  'dashboard.entity.spec_reference': 'referensi spesifikasi',
  'dashboard.entity.tracking': 'pengaturan pelacakan',
}
